import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Step from '../steps/Step';

import styles from '../../../styles/displays/step-preview.module.scss';

const propTypes = {
    step: PropTypes.shape({}).isRequired,
    game: AppPropTypes.game.isRequired,
    leaderboard: PropTypes.shape({}).isRequired,
};

function StepPreview({ step, game, leaderboard }) {
    const themeClassName = useThemeClassName(styles);
    return game !== null ? (
        <div className={classNames([styles.container, themeClassName])}>
            <Step
                className={styles.preview}
                game={game}
                step={step}
                leaderboard={leaderboard}
                isPreview
            />
        </div>
    ) : null;
}

StepPreview.propTypes = propTypes;

export default StepPreview;
